import app from '../app';
import Modal from '../../common/components/Modal';
import Button from '../../common/components/Button';
import Stream from '../../common/utils/Stream';
import avatar from '../../common/helpers/avatar';
import Select from '../../common/components/Select';
import PuzzleDebunkerModal from '../../forum/dianLiang/PuzzleDebunkerModal';
import PuzzleTriggerModal from '../../forum/dianLiang/PuzzleTriggerModal';
import PuzzleTipModal from '../../forum/dianLiang/PuzzleTipModal';
import PuzzleTopicModal from '../../forum/dianLiang/PuzzleTopicModal';
import { PowerGlitch } from 'powerglitch';

export default class PuzzleBadgeModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.attrs = vnode.attrs;
    if (app.data['guessGameInfo']) {
      this.guessGameInfo  = JSON.parse(app.data['guessGameInfo']);
    }
    this.twitterLink = this.guessGameInfo?.twitterLink;
    this.insLink = this.guessGameInfo?.insLink;
    this.tiktokLink = this.guessGameInfo?.tiktokLink;
    this.facebookLink = this.guessGameInfo?.facebookLink;
    this.puzzleList = [
      {
        src: `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgamehuizhangpc/hz-yq-1.webp`,
        content: 'strength does not come from a physical capacity. It comes from an indomitable will.',
        name: 'Gandhi',
        tip: '↙',
      },
      {
        src: `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgamehuizhangpc/hz-yoq2-1.webp`,
        src2: `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgamehuizhangpc/hz-yoq2-2.webp`,
        content: "To get someone's friendship, I will be the first to be friendly to someone.",
        name: 'Emerson',
        tip: '❷③①❶❷❺③①',
      },
      {
        src: `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgamehuizhangpc/hz-cs-1.webp`,
        content: 'Reliability is built not in a moment, but over time, through consistency and truth.',
        name: 'Stephen Covey',
        tip: '',
      },
      {
        src: `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgamehuizhangpc/hz-ax-1.webp`,
        content: 'You must allow me to tell you how ardently I admire and love you.',
        name: 'Aristotle',
        tip: 'd(▔▽▔)d',
      },
      {
        src: `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgamehuizhangpc/hz-zs-1.webp`,
        content: 'Knowledge is POWER.',
        name: 'Francis Bacon',
        tip: 'patience',
      },
      {
        src: `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgamehuizhangpc/hz-cz-1.webp`,
        content: 'I think one’s feelings waste themselves in words; they ought all to be distilled into actions which bring results.',
        name: 'Nightingale',
        tip: '17',
      },
      {
        src: `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgamehuizhangpc/hz-xw-1.webp`,
        content: 'We must accept finite disappointment, but never lose infinite hope.',
        name: 'Martin Luther King, Jr.',
        tip: 'dream →',
      },
      {
        src: `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgamehuizhangpc/hz-gm-1.webp`,
        content: "The glorious lamp of heaven, the radiant sun, Is Nature's eye.",
        name: 'John Dryden.',
        tip: '↓ ◑ ↑',
      },
    ];
    this.longPressTimer = null;
    this.isLongPress = false;
    this.clickNum = 0;
    this.timeoutId = null; // 用于存储 setTimeout 的 ID
    this.shareBtn = false; // 分享按钮的状态
    this.puzzleTextShow = false;
    this.isReversed = false; // 标记当前旋转方向
    this.debunkerLoading = false; // 解密按钮的加载状态
  }

  className() {
    return 'Modal--small dl-modal-small puzzle-badge-modal';
  }

  title() {
    return;
  }
  oncreate() {
    const element = document.getElementById('badge-image');
    element.addEventListener('click', () => {
      element.animate([{ transform: 'scale(1)' }, { transform: 'scale(0.9)' }, { transform: 'scale(1)' }], {
        duration: 200,
        iterations: 1,
      });
    });
    // if (this.attrs.index === 6) {
    //   const infinity = document.getElementById('infinity');
    //   infinity.addEventListener('click', () => {
    //     infinity.animate([{ transform: 'scale(1)' }, { transform: 'scale(0.9)' }, { transform: 'scale(1)' }], {
    //       duration: 200,
    //       iterations: 1,
    //     });
    //   });
    // }
    if (this.attrs.index === 3) {
      // 通用事件处理函数
      const startHandler = (e) => {
        e.preventDefault();
        this.isLongPress = false;
        this.longPressTimer = setTimeout(() => {
          this.isLongPress = true;
          app.modal.show(PuzzleTopicModal, { index: this.attrs.index }, true); // 触发弹窗
        }, 3000);
      };

      const cancelHandler = () => {
        clearTimeout(this.longPressTimer);
        this.longPressTimer = null;
      };

      // 移动端事件
      element.addEventListener('touchstart', startHandler);
      element.addEventListener('touchend', cancelHandler);
      element.addEventListener('touchcancel', cancelHandler);

      // PC端事件
      element.addEventListener('mousedown', startHandler);
      element.addEventListener('mouseup', cancelHandler);
      element.addEventListener('mouseleave', cancelHandler);

      // 移动超过阈值取消
      element.addEventListener('touchmove', (e) => {
        if (Math.abs(e.changedTouches[0].clientX - startX) > 10) cancelHandler();
      });
    }
    if (this.attrs.index === 6) {
      this.audio = document.getElementById('puzzle-audio');
      this.audio.addEventListener('ended', () => {
        this.audio.currentTime = 0;
      });
    }
    if (this.attrs.index === 1) {
      this.rotateFunction();
    }
    const glitchOptions = {
      playMode: 'always',
      // createContainers: true,
      hideOverflow: true,
      timing: {
        duration: 3000,
        iterations: Infinity,
        easing: "linear"
      },
      glitchTimeSpan: {
        start: 0.4,
        end: 0.6,
      },
      shake: {
        velocity: 1,
        amplitudeX: 0,
        amplitudeY: 0,
      },
      slice: {
        count: 4,
        velocity: 30,
        minHeight: 0.01,
        maxHeight: 0.05,
        hueRotate: true,
      },
    };
    PowerGlitch.glitch('.Modal-content', glitchOptions);
  }

  content() {

    return (
      <div>
        <div className="puzzle-badge-box">
          <div className="puzzle-badge-img">
            <img
              id="badge-image"
              className={`badge-image img${this.attrs.index}`}
              src={this.puzzleList[this.attrs.index].src}
              onclick={() => this.onTrigger()}
            />
            {this.attrs.index === 6 && this.puzzleTextShow && <div className="img-text">forever Koji</div>}
            {this.attrs.index === 2 && (
              <div id="horn" className="horn">
                <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgamehuizhangpc/hz-cs1.webp`}></img>
                <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgamehuizhangpc/hz-cs2.webp`}></img>
                <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgamehuizhangpc/hz-cs3.webp`}></img>
                <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgamehuizhangpc/hz-cs4.webp`}></img>
              </div>
            )}
          </div>
          {this.attrs.index === 2 && (
            <div className="share-container">
              <Button className="puzzle-badge-share-btn" onclick={() => (this.shareBtn = !this.shareBtn)}></Button>

              <div className={`share-buttons ${this.shareBtn ? 'active' : ''}`}>
                <a href={this.twitterLink}>
                  <img className="share-item wechat" src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgamehuizhangpc/hz-cs-btn-fx4.webp`}></img>
                </a>
                <a href={this.insLink}>
                  <img className="share-item wechat" src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgamehuizhangpc/hz-cs-btn-fx3.webp`}></img>
                </a>
                <a href={this.tiktokLink}>
                  <img className="share-item link" src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgamehuizhangpc/hz-cs-btn-tiktok.webp`}></img>
                </a>
                <a href={this.facebookLink}>
                  <img className="share-item facebook" src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgamehuizhangpc/hz-cs-btn-fx1.webp`}></img>
                </a>
              </div>
            </div>
          )}
          {this.attrs.index === 6 && (
            <div className="share-container">
              <Button className='audio-btn' onclick={() => this.togglePlay()}></Button>
              <audio
                id="puzzle-audio"
                src="https://img.forum.stormsdk.com/shumashou/upload/2025-05-27/1748334641-764588-f3bbf9e1-f4de-4014-a6c7-8fcf27dfabe3.mp3"
              ></audio>
            </div>
          )}
          <div className="puzzle-content">
            <p>{this.puzzleList[this.attrs.index].content}</p>
            <p style="text-align:right">———{this.puzzleList[this.attrs.index].name}</p>
          </div>
          <div className="puzzle-badge-footer">
            {this.attrs.index !== 2 && (
              <div className="puzzle-badge-tip">
                {this.attrs.index === 6 &&
                  (this.clickNum === 11 ? (
                    <div className="butterfly">
                      <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgamechunzhenpc/hd-gif.webp`}></img>
                    </div>
                  ) : (
                    <div id="infinity" onclick={() => this.onClickWQ()}>
                      ∞
                    </div>
                  ))}
                {this.puzzleList[this.attrs.index].tip}
                {this.attrs.index === 5 && (
                  <img className="light-bulb" src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgamechunzhenpc/btm-tips-deng.webp`}></img>
                )}
              </div>
            )}
          </div>
        </div>
        <Button loading={this.debunkerLoading} disabled={this.debunkerLoading} className="puzzle-jiemi" onclick={() => this.showDebunkerModal()}>
          {app.translator.trans('dl_setGuessGame.forum.PuzzleBadgeModal.bird')}
        </Button>
      </div>
    );
  }
  showDebunkerModal() {
    let list = [];
    this.debunkerLoading = true;

    app
      .request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + '/guessGame/' + this.attrs.index,
        params: {
          page: {
            limit: 50,
            offset: 0,
          },
        },
      })
      .then((res) => {
        if (res) {
          list = res;
        }
        this.debunkerLoading = false;
        app.modal.show(PuzzleDebunkerModal, { puzzleList: list.data.length > 0 ? list.data.slice(0, -1) : [], index: this.attrs.index }, true);
      });
  }
  onTrigger() {
    if (this.isLongPress) {
      this.isLongPress = false;
      return;
    }
    const triggerId = this.attrs.index;

    if (triggerId === 4) {
      app.modal.show(PuzzleTriggerModal, { index: this.attrs.index }, true);
    }
    if (triggerId === 6) {
      app.modal.show(PuzzleDebunkerModal, { index: this.attrs.index, trigger: true }, true);
    }
    if (triggerId === 0 || triggerId === 5) {
      app.modal.show(PuzzleTopicModal, { index: this.attrs.index }, true);
    }
    if (triggerId === 2) {
      const element = document.getElementById('horn');
      element.classList.add('click-flicker');
      // 动画结束后重置状态
      element.addEventListener('animationend', () => {
        element.classList.remove('click-flicker');
      }, { once: true });
    }
  }
  onClickWQ() {
    // 每次点击先清除已有定时器
    clearTimeout(this.timeoutId);
    this.clickNum++;
    if (this.clickNum === 11) {
      setTimeout(() => {
        this.puzzleTextShow = true;
        m.redraw();
      }, 3000);
    } else {
      // 存储新定时器ID
      this.timeoutId = setTimeout(() => {
        this.clickNum = 0;
      }, 1000);
    }
  }
  togglePlay() {
    if (this.audio.paused) {
      this.audio.play();
    } else {
      this.audio.pause();
      this.audio.currentTime = 0;
    }
  }
  rotateFunction() {
    const imgElement = document.getElementById('badge-image');

    imgElement.addEventListener('click', () => {
      // 移除之前的动画类
      imgElement.classList.remove('rotate-counter', 'rotate-clock');

      // 根据状态选择动画方向
      if (this.isReversed) {
        imgElement.classList.add('rotate-clock');
      } else {
        imgElement.classList.add('rotate-counter');
      }

      // 动画结束后切换图片并重置状态
      imgElement.addEventListener(
        'animationend',
        () => {
          // 切换图片
          imgElement.src = this.isReversed ? this.puzzleList[1].src : this.puzzleList[1].src2;
          // 重置动画状态
          imgElement.classList.remove('rotate-counter', 'rotate-clock');
          this.isReversed = !this.isReversed;
        },
        { once: true }
      );
    });
  }
}
